import { HTTP } from '@/api/http-common'

export default {
  getAccount (callback, param) {
    HTTP.get('account?appID=' + param['appID'] + '&channelID=' + param['channelID'] + '&customToken=' + param['customToken'] + '&domain=' + param['domain']).then(response => {
      if (response.status === 200 || response.status === 204) {
        callback(response)
      } else if (response.status === 401) {
        console.log('Error: authentication fail')
      }
    }).catch(e => {
      console.log(e)
    })
  },
  createAccount (callback, param) {
    HTTP.post('account', param).then(response => {
      if (response.status === 201) {
        callback(response)
      } else if (response.status === 401) {
        console.log('Error: authentication fail')
      }
    }).catch(e => {
      console.log(e)
    })
  },
  checkVelaeasyLogin (callback, param) {
    HTTP.post('velaeasy', param).then(response => {
      if (response.status === 200 || response.status === 204) {
        callback(response)
      } else if (response.status === 401) {
        console.log('Error: authentication fail')
      }
    }).catch(e => {
      console.log(e)
    })
  },
  updateAccountInfo (callback, param) {
    HTTP.put('account', param).then(response => {
      if (response.status === 200) {
        callback(response)
      } else if (response.status === 401) {
        console.log('Error: authentication fail')
      }
    }).catch(e => {
      console.log(e)
    })
  },
  getShopAuthToken (callback, param) {
    HTTP.post('shop/auth', param).then(response => {
      if (response.status === 200) {
        callback(response)
      } else if (response.status === 401) {
        console.log('Error: authentication fail')
      }
    }).catch(e => {
      console.log(e)
    })
  },
  createShopByMultiVelaeasyLogin (callback, param) {
    HTTP.post('velaeasy/domain', param).then(response => {
      if (response.status === 200) {
        callback(response)
      } else if (response.status === 401) {
        console.log('Error: authentication fail')
      }
    }).catch(e => {
      console.log(e)
    })
  },
  logout (callback, param) {
    HTTP.put('account/logout', param).then(response => {
      if (response.status === 201) {
        callback(response)
      } else if (response.status === 401) {
        console.log('Error: authentication fail')
      }
    }).catch(e => {
      console.log(e)
    })
  }
}
